<div
  class="notification-dropdown"
  #notificationDropdown
  [class.notification-dropdown--mobile]="isMobileView"
  [class.is-open]="isOpen"
  [style.display]="isOpen ? 'block' : 'none'"
  [style.width]="isMobileView ? null : panelWidth">
  <div class="notification-panel" [style.max-height]="maxHeight">
    <!-- Desktop / web layout (unchanged) -->
    <ng-container *ngIf="!isMobileView">
      <div class="panel-header">
        <button
          *ngIf="showViewAll"
          type="button"
          class="view-all-btn"
          (click)="onViewAllClick()">
          {{ viewAllLabel | translate }}
        </button>
        <button
          *ngIf="showMarkAllAsRead"
          class="mark-all-btn"
          (click)="onMarkAllAsReadClick()">
          <span class="mark-icon">
            <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="1.5,5 4,7.5 8.5,2.5"/>
            </svg>
          </span>
          {{ markAllAsReadLabel | translate }}
        </button>
        <ng-content select="[header-actions]"></ng-content>
      </div>

      <div
        class="notifications-list"
        #desktopNotificationsList
        (scroll)="onMobileListScroll()">
        <div
          class="notification-item"
          [class.unread]="!notification.read"
          [class.read]="notification.read"
          *ngFor="let notification of (notifications || []); let i = index; trackBy: trackByNotificationId"
          [style.animation-delay]="(i * 0.07) + 's'"
          (click)="onNotificationClick(notification)">
          <div class="notification-item-top">
            <div class="avatar" [ngClass]="getAvatarClass(i)">
              <img
                *ngIf="notification.read && getNotificationImage(notification)"
                [src]="getNotificationImage(notification) || ''"
                [alt]="notification.title"
                (error)="onImageError($event)"
                class="avatar-image" />
              <span
                class="avatar-initials"
                [style.display]="notification.read && getNotificationImage(notification) ? 'none' : 'flex'">
                {{ getInitials(notification.title) }}
              </span>
              <span class="badge-dot" *ngIf="getUnreadCountForType(notification.notification_type || '') > 0 && isFirstOfType(notification, i)">
                {{ getUnreadCountForType(notification.notification_type || '') }}
              </span>
            </div>
            <div class="notification-content">
              <div class="notification-title">{{ notification.title || ('TFNotification.NoTitle' | translate) }}</div>
              <div class="notification-desc">{{ notification.message || notification.description || ('TFNotification.NoDescription' | translate) }}</div>
              <ng-container *ngIf="customActionsTemplate">
                <ng-container *ngTemplateOutlet="customActionsTemplate; context: { $implicit: notification }"></ng-container>
              </ng-container>
            </div>
          </div>

          <div class="notification-footer" [class.notification-footer--read]="notification.read">
            <div class="read-status" *ngIf="notification.read">
              <span class="read-status-label">{{ 'TFNotification.Read' | translate }}</span>
              <span class="read-status-icon" aria-hidden="true">
                <i-feather name="check" width="14" height="14"></i-feather>
              </span>
            </div>
            <span class="notification-time">{{ formatNotificationTime(notification.created_at) }}</span>
          </div>
        </div>

        <div class="empty-state" *ngIf="!notifications || notifications.length === 0">
          {{ getEmptyStateMessage() }}
        </div>
      </div>
    </ng-container>

    <!-- Mobile layout -->
    <ng-container *ngIf="isMobileView">
      <div class="panel-header panel-header--mobile">
        <h2 class="panel-title">{{ 'TFNotification.Notification' | translate }}</h2>
        <button
          *ngIf="showMarkAllAsRead"
          type="button"
          class="mark-all-btn mark-all-btn--mobile"
          (click)="onMarkAllAsReadClick()">
          {{ 'TFNotification.MarkAllRead' | translate }}
        </button>
      </div>

      <div class="notifications-list-wrap notifications-list-wrap--mobile">
        <div
          class="notification-scroll-hint notification-scroll-hint--top"
          *ngIf="showScrollUp"
          aria-hidden="true">
          <svg class="notification-scroll-chevron" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L6 1L11 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div
          class="notifications-list notifications-list--mobile"
          #mobileNotificationsList
          [class.is-entering]="playEnterAnimation"
          (scroll)="onMobileListScroll()">
          <ng-container *ngFor="let section of mobileNotificationSections; trackBy: trackBySectionLabel">
            <div class="notification-section-label">{{ section.labelKey | translate }}</div>
            <div
              class="notification-item notification-item--mobile"
              [class.unread]="!notification.read"
              [class.read]="notification.read"
              *ngFor="let notification of section.items; let i = index; trackBy: trackByNotificationId"
              [style.animation-delay]="(i * 0.06) + 's'"
              (click)="onNotificationClick(notification)">
              <span class="notification-status-col" aria-hidden="true">
                <span class="unread-dot" *ngIf="!notification.read"></span>
              </span>
              <div class="mobile-notification-body">
                <div class="notification-title">{{ notification.title || ('TFNotification.NoTitle' | translate) }}</div>
                <div class="notification-desc">{{ notification.message || notification.description || ('TFNotification.NoDescription' | translate) }}</div>
                <span class="notification-time-mobile">{{ formatRelativeTime(getNotificationDate(notification)) }}</span>
              </div>
            </div>
          </ng-container>

          <div class="empty-state" *ngIf="!notifications || notifications.length === 0">
            {{ getEmptyStateMessage() }}
          </div>
        </div>
      </div>

      <footer class="panel-footer panel-footer--mobile" *ngIf="showViewAll">
        <div
          class="notification-scroll-hint notification-scroll-hint--bottom"
          *ngIf="showScrollDown"
          aria-hidden="true">
          <svg class="notification-scroll-chevron" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <button
          type="button"
          class="view-all-btn view-all-btn--mobile-footer"
          (click)="onViewAllClick()">
          {{ viewAllMobileLabel | translate }}
        </button>
      </footer>
    </ng-container>
  </div>
</div>
